import { createReducer, createAction } from '@reduxjs/toolkit';

import { SwitchManager, WebSocketManager, Loadable } from 'models';
import { makeThunkFromAPICall } from 'state';

export type SwitchesState = {
    listByGroundStation: Record<number, Loadable<SwitchManager.Switch[]>>;
};

const initialState: SwitchesState = {
    listByGroundStation: {},
};

export const [getSwitch, setSwitch] = makeThunkFromAPICall(
    SwitchManager.getSwitchById,
    'switches/get',
);

export const [getSwitchList, setSwitchList] = makeThunkFromAPICall(
    SwitchManager.listSwitches,
    'switches/list',
);

export const onSwitchValueUpdated =
    createAction<WebSocketManager.SwitchValueUpdate>('Switches/update-value');

export const switchesReducer = createReducer(initialState, (builder) => {
    builder.addCase(setSwitchList, (state, action) => {
        return {
            ...state,
            listByGroundStation: {
                ...state.listByGroundStation,
                [action.payload.input.groundStationId]: {
                    ...(state.listByGroundStation[
                        action.payload.input.groundStationId
                    ] ?? {}),
                    ...action.payload.loadable,
                },
            },
        };
    });

    builder.addCase(onSwitchValueUpdated, (state, { payload }) => {
        return {
            ...state,
            listByGroundStation: {
                ...state.listByGroundStation,
                [payload.ground_station_id]: {
                    ...state.listByGroundStation[payload.ground_station_id],
                    object: state.listByGroundStation[
                        payload.ground_station_id
                    ].object?.map((switchObj) => {
                        if (payload.switch_id !== switchObj.switchId)
                            return switchObj;

                        return {
                            ...switchObj,
                            value: payload.value,
                        };
                    }),
                },
            },
        };
    });
});

export const switchesActions = {
    getSwitchList,
    setSwitchList,
    getSwitch,
    onSwitchValueUpdated,
};

export default switchesReducer;
